import React, { useState, useEffect, useContext } from "react";
import Context from "../../Context";

import { useToast } from "../../components/ui";
import { FaPlus } from "react-icons/fa";
import { IoMdCalendar } from "react-icons/io";
import { Header } from "../../components/modules";
import { FiCreditCard } from "react-icons/fi";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "../../components";
import { TimePickerDemo } from "../../components/base";
import {
  Switch,
  Calendar,
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "../../components/ui";
import constant, { statuses } from "../../constants";
import { Spinner } from "reactstrap";
import { MdOutlineDeleteOutline } from "react-icons/md";
import { FaTimes, FaCheckCircle } from "react-icons/fa";
import { resizeImage, validate } from "../../util";
import { FaXmark } from "react-icons/fa6";
import { DatePicker, Space } from "antd";
import dayTh from "dayjs/locale/th";
import dayjs from "dayjs";

export const ManageDonate = () => {
  const { callApi, updateConfig, configs } = Context();
  const { toast } = useToast();
  const [allProducts, setAllProducts] = useState([]);

  const [loading, setLoading] = useState(true);
  const [calendarOpen, setCalendarOpen] = useState(false);
  const [selectedDonate, setSelectedDonate] = useState(false);

  useEffect(() => {
    getDonate();
  }, []);

  const getDonate = async () => {
    const result = await callApi(
      "donates-getAll",
      { limit: 10000 },
      { notShowLoading: true }
    );
    setAllProducts(result);
    setLoading(false);
  };

  const updateChange = async (key, value) => {
    setLoading(true);
    if (!window.confirm("ท่านต้องการแก้ไขใช่หรือไม่")) return;
    const { status } = await callApi(
      "configs-edit",
      {
        id: "general",
        key: key,
        value: value,
      },
      { notShowLoading: true }
    );

    if (status) {
      toast({
        className: "bg-[rgb(59,176,101)]",
        title: `อัพเดตข้อมูลสำเร็จ`,
      });
    } else {
      toast({
        className: "bg-[#c15b78]",
        title: `อัพเดตข้อมูลไม่สำเร็จ`,
      });
    }
    setCalendarOpen(false);
    setLoading(false);
    updateConfig();
  };
  return (
    <div
      className="h-fit w-full min-w-[1024px] max-w-[1600px] mx-auto"
      id="main"
    >
      <Header
        header="Donates"
        subHeader={`จัดการบริจาค`}
        icon={<FiCreditCard className="text-blue" />}
      />

      <div className="relative bg-white w-full rounded-lg shadow-md mt-3">
        <div className="flex  items-center p-3 border-b border-[#E5E7E9] justify-between">
          <p className="font-semibold text-xl">จัดการบริจาค</p>
          <button
            className="bg-blue flex gap-2 items-center rounded-lg py-2 px-3  text-white font-semibold hover:opacity-75 duration-150 disabled:opacity-45 disabled:cursor-not-allowed"
            // disabled={isEmpty(preparedImport) || loading}
            onClick={() => setSelectedDonate({})}
          >
            <FaPlus /> สร้างบริจาคใหม่
          </button>
        </div>
        <div className="p-3 grid grid-cols-5">
          <div>
            <p className="font-medium">เปิดบริจาค</p>

            <Switch
              disabled={loading}
              className={`mt-2.5`}
              type="switch"
              checked={configs.isOpen.donate}
              onCheckedChange={(e) => {
                updateChange("isOpen.donate", e);
              }}
            />
          </div>
        </div>
      </div>

      {selectedDonate && (
        <SelectedDonate
          selectedDonate={selectedDonate}
          setSelectedDonate={setSelectedDonate}
          getDonate={getDonate}
        />
      )}

      <div className="relative bg-white w-full rounded-lg shadow-md mt-3 border border-[#E5E7E9] overflow-hidden">
        <div className="flex items-center p-3 border-b border-[#E5E7E9] justify-between">
          <p className="font-semibold text-xl">บริจาคทั้งหมด</p>
        </div>
        <Table>
          <TableHeader className={`bg-[#f2f3f5]`}>
            <TableRow>
              <TableHead className={`text-center`}>ลำดับที่</TableHead>
              <TableHead className={``}></TableHead>
              <TableHead className={`text-center`}>รูป</TableHead>
              <TableHead className={``}>ชื่อ</TableHead>
              <TableHead className={`text-right`}>ยอดบริจาค (บาท)</TableHead>
              <TableHead className={`text-right`}>ยอดบริจาค (คะแนน)</TableHead>
              <TableHead className={`text-center`}>สถานะ</TableHead>
              <TableHead></TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {loading ? (
              <TableRow>
                <TableCell colSpan="7">
                  <div className="w-full h-[500px] flex justify-center items-center">
                    <Spinner className="w-4 h-4" />
                  </div>
                </TableCell>
              </TableRow>
            ) : (
              allProducts
                .sort((a, b) => b.expireAt - a.expireAt)
                .map((coupon, index) => {
                  return (
                    <CouponCell
                      coupon={coupon}
                      key={coupon.id}
                      index={index}
                      setSelectedDonate={setSelectedDonate}
                    />
                  );
                })
            )}
          </TableBody>
        </Table>
      </div>
    </div>
  );
};

const CouponCell = ({ coupon, setSelectedDonate, index }) => {
  const { callApi } = Context();
  const [loading, setLoading] = useState(false);
  const { toast } = useToast();

  // const updateChange = async (key, value) => {
  //   setLoading(true);
  //   if (!window.confirm("ท่านต้องการแก้ไขใช่หรือไม่")) return;
  //   const { status } = await callApi("coupons-editCoupon", {
  //     id: coupon.id,
  //     key: key,
  //     value: value,
  //   });

  //   if (status) {
  //     toast({
  //       className: "bg-[rgb(59,176,101)]",
  //       title: `อัพเดตข้อมูลสำเร็จ`,
  //     });
  //   } else {
  //     toast({
  //       className: "bg-[#c15b78]",
  //       title: `อัพเดตข้อมูลไม่สำเร็จ`,
  //     });
  //   }

  //   setLoading(false);
  // };

  return (
    <TableRow>
      <TableCell
        className={`text-center
           font-semibold`}
      >
        {index + 1}
      </TableCell>
      <TableCell className="font-semibold">
        {coupon.isHotDeal ? "🔥" : ""}
      </TableCell>
      <TableCell className={``}>
        {coupon.image ? (
          <img
            className="max-h-10 mx-auto"
            src={coupon.image}
            alt={coupon.shortId}
          />
        ) : (
          "-"
        )}
      </TableCell>
      <TableCell className="font-semibold">{coupon.name}</TableCell>
      <TableCell className="font-semibold text-right">
        {coupon.donateCash.toLocaleString()} บาท
      </TableCell>
      <TableCell className="font-semibold text-right">
        {coupon.donatePoint.toLocaleString()} คะแนน
      </TableCell>
      <TableCell className="font-semibold">
        <div
          className={`${coupon.status === statuses.ACTIVE ? "bg-green" : "bg-[#c15b78]"
            } min-w-14 w-fit px-3 py-2 text-white text-center rounded-lg mx-auto cursor-pointer`}
        // onClick={() =>
        //   updateChange(
        //     "status",
        //     coupon.status === statuses.ACTIVE
        //       ? statuses.INACTIVE
        //       : statuses.ACTIVE
        //   )
        // }
        >
          {loading ? (
            <Spinner className="w-4 h-4 " />
          ) : (
            constant.statusesTranslate[coupon.status] || "-"
          )}
        </div>
      </TableCell>
      <TableCell className={`text-center`}>
        <button
          className="bg-blue rounded-lg py-2 px-3 text-white font-semibold hover:opacity-75 duration-150 disabled:opacity-45 disabled:cursor-not-allowed"
          // disabled={isEmpty(preparedImport) || loading}
          onClick={() => {
            setSelectedDonate(coupon);
            document
              .getElementById("main")
              .scrollIntoView({ behavior: "smooth", block: "start" });
          }}
        >
          แก้ไข
        </button>
      </TableCell>
    </TableRow>
  );
};

const SelectedDonate = ({ selectedDonate, setSelectedDonate, getDonate }) => {
  const { callApi } = Context();
  const { toast } = useToast();
  const [donate, setDonate] = useState(false);
  const [previewImage, setPreviewImage] = useState(false);
  // const [coverImage, setCoverImage] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setDonate(selectedDonate);
    setPreviewImage(selectedDonate.image);
    // setCoverImage(selectedDonate.previewImage);
  }, [selectedDonate]);

  const handleEdit = async () => {
    setLoading(true);
    const result = await callApi(
      selectedDonate.id ? "donates-editDonate" : "donates-createDonate",
      {
        id: donate.id,
        previousCash: selectedDonate.donateCash || 0,
        previousPoint: selectedDonate.donatePoint || 0,
        ...donate,
      },
      { notShowLoading: true }
    );
    if (result.status) {
      getDonate();
      toast({
        className: "bg-[rgb(59,176,101)]",
        title: (
          <div className="flex gap-2 items-center">
            <FaCheckCircle /> อัพเดตข้อมูลสำเร็จ
          </div>
        ),
      });
      setSelectedDonate(false);
    } else {
      toast({
        className: "bg-[#c15b78]",
        title: (
          <div className="flex gap-2 items-center">
            <FaCheckCircle /> อัพเดตข้อมูลไม่สำเร็จ
          </div>
        ),
        description: result.message,
      });
    }
    setLoading(false);
  };

  const handleDelete = async () => {
    if (window.confirm("ต้องการแก้ไขข้อมูลใช่หรือไม่")) {
      setLoading(true);
      const result = await callApi(
        "donates-deleteDonate",
        {
          id: donate.id,
        },
        { notShowLoading: true }
      );
      if (result.status) {
        setSelectedDonate(false);
        getDonate();
        toast({
          className: "bg-[rgb(59,176,101)]",
          title: (
            <div className="flex gap-2 items-center">
              <FaCheckCircle /> อัพเดตข้อมูลสำเร็จ
            </div>
          ),
        });
      } else {
        toast({
          className: "bg-[#c15b78]",
          title: (
            <div className="flex gap-2 items-center">
              <FaCheckCircle /> อัพเดตข้อมูลไม่สำเร็จ
            </div>
          ),
          description: result.message,
        });
      }
      setLoading(false);
    }
  };

  if (!selectedDonate) {
    return (
      <div className="relative mt-4 bg-white border-[#E5E7E9] shadow-md h-[350px] flex justify-center items-center w-full rounded-lg overflow-hidden">
        <Spinner className="w-3 h-3" />
      </div>
    );
  }
  return (
    <div className="relative bg-white w-full rounded-lg shadow-md mt-4 border border-[#E5E7E9] overflow-hidden">
      {loading && (
        <div className="z-50 bg-[rgb(255,255,255,0.7)] absolute h-full w-full flex justify-center items-center">
          <Spinner className="w-4 h-4 " />
        </div>
      )}
      <div className="flex items-center p-3 border-b border-[#E5E7E9] justify-between">
        <p className="font-semibold text-xl">
          {donate.id ? donate.name : "สร้างบริจาค"}
        </p>
        <FaXmark
          className="text-lg text-red-600 cursor-pointer"
          onClick={() => setSelectedDonate(false)}
        />
      </div>
      <div className="relative grid grid-cols-3 gap-3 p-3">
        <div className="relative  row-span-3 border-1 p-2 h-fit border-[#E5E7E9] ">
          <label htmlFor="donateImage" className="cursor-pointer">
            <p className="font-semibold">รูปบริจาค</p>
            <img src={previewImage || ""} className="" alt={donate.id} />
          </label>

          <input
            style={{
              marginBottom: "15px",
              visibility: "hidden",
              position: "absolute",
              display: "none",
            }}
            id="donateImage"
            type="file"
            onChange={async (e) => {
              const file = e.target.files[0];
              const base64 = await resizeImage(file);
              if (base64) {
                const previewUrl = URL.createObjectURL(file);
                setPreviewImage(previewUrl);
                setDonate((prevState) => ({
                  ...prevState,
                  image: base64,
                }));
              } else {
                alert("อัพโหลด ได้เฉพาะ ไฟล์รูปภาพ นามสกุล jpg หรือ png");
              }
            }}
          />
        </div>
        <div className="grid col-span-2 grid-cols-2 gap-3">
          <div>
            <p className="font-semibold">สถานะ</p>
            <div className="flex">
              <select
                className={`${donate.status === constant.statuses.ACTIVE
                  ? "bg-[rgb(59,176,101)]"
                  : "bg-[#c15b78]"
                  } text-white border-1 w-full border-gray-300 py-1.5 px-2 font-semibold rounded-lg placeholder:text-sm disabled:text-gray-500 disabled:border-gray-200 disabled:cursor-not-allowed`}
                value={donate?.status || ""}
                onChange={(e) =>
                  setDonate((prevState) => ({
                    ...prevState,
                    status: e.target.value,
                  }))
                }
              >
                <option value=""></option>
                <option value={constant.statuses.ACTIVE}>
                  {constant.statusesTranslate.active}
                </option>
                <option value={constant.statuses.INACTIVE}>
                  {constant.statusesTranslate.inactive}
                </option>
                <option value={statuses.REMOVED}>ปิดใช้งาน</option>
              </select>
            </div>
          </div>
          <div className="">
            <p className="font-semibold">ชื่อสถานที่/โครงการบริจาค</p>
            <div className="flex">
              <input
                className="border-1 w-full border-gray-300 py-1.5 px-2 font-semibold rounded-lg placeholder:text-sm"
                type="text"
                value={donate?.name}
                onChange={(e) => {
                  setDonate((prevState) => ({
                    ...prevState,
                    name: e.target.value,
                  }));
                }}
                placeholder="ชื่อ"
              />
            </div>
          </div>
          <div className="col-span-2">
            <p className="font-semibold">รายละเอียด</p>
            <div className="flex">
              <textarea
                type="textArea"
                className="border w-full py-1 border-[#1a1b1c] rounded-lg font-semibold disabled:cursor-not-allowed disabled:opacity-65"
                value={donate?.detail}
                onChange={(e) => {
                  setDonate((prevState) => ({
                    ...prevState,
                    detail: e.target.value,
                  }));
                }}
              />
            </div>
          </div>

          <div>
            <p className="font-semibold">ยอดบริจาค (บาท)</p>
            <div className="flex">
              <input
                type="number"
                className={`border-1 w-full border-gray-300 py-1.5 px-2 font-semibold rounded-lg placeholder:text-sm disabled:text-gray-500 disabled:border-gray-200 disabled:cursor-not-allowed`}
                value={donate?.donateCash}
                onChange={(e) => {
                  setDonate((prevState) => ({
                    ...prevState,
                    donateCash: e.target.value,
                  }));
                }}
              />
            </div>
          </div>
          <div>
            <p className="font-semibold">ยอดบริจาค (คะแนน)</p>
            <div className="flex">
              <input
                type="number"
                className={`border-1 w-full border-gray-300 py-1.5 px-2 font-semibold rounded-lg placeholder:text-sm disabled:text-gray-500 disabled:border-gray-200 disabled:cursor-not-allowed`}
                value={donate?.donatePoint}
                onChange={(e) => {
                  setDonate((prevState) => ({
                    ...prevState,
                    donatePoint: e.target.value,
                  }));
                }}
              />
            </div>
          </div>
          <div className="col-span-2 flex gap-2 items-center">
            <input
              className=" cursor-pointer"
              id="hotdeal"
              type="checkbox"
              checked={donate.isHotDeal || false}
              onChange={(e) => {
                setDonate((prevState) => ({
                  ...prevState,
                  isHotDeal: !prevState.isHotDeal,
                }));
              }}
            />
            <label htmlFor="hotdeal" className="font-semibold cursor-pointer">
              🔥
            </label>
          </div>
          <div className="col-span-2 flex gap-2 relative">
            <button
              className="col-span-2 bg-blue rounded-lg w-full py-2 font-semibold text-white hover:opacity-85"
              onClick={() => handleEdit()}
            >
              {/* <FaPlus /> */} บันทึก
            </button>
            <button
              className="col-span-2 flex justify-center items-center bg-[#c15b78] rounded-lg w-16 py-2 font-semibold text-white hover:opacity-85"
              onClick={() =>
                donate.id ? handleDelete() : setSelectedDonate(false)
              }
            >
              <MdOutlineDeleteOutline />
              {/* <FaPlus /> */}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
